import { render, staticRenderFns } from "./Testimonios.vue?vue&type=template&id=e322903a&scoped=true"
import script from "./Testimonios.vue?vue&type=script&lang=ts"
export * from "./Testimonios.vue?vue&type=script&lang=ts"
import style0 from "./Testimonios.vue?vue&type=style&index=0&id=e322903a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e322903a",
  null
  
)

export default component.exports